import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

let CategoryOptions = [
  { value: '1', label: 'Party A' },
  { value: '2', label: 'Party B' },
  { value: '3', label: 'Party C' },
  { value: '4', label: 'Party D' },
  { value: '5', label: 'Party E' },
];

class LoanPartyList extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      options: [],
      selected: null,
    };
  }

  componentDidMount() {
    let selected = null;

    if (
      typeof this.props.defaultValue === 'number' &&
      CategoryOptions[this.props.defaultValue]
    ) {
      selected = CategoryOptions[this.props.defaultValue - 1];
    } else if (this.props.value) {
      selected = CategoryOptions.find(
        ({ value }) => value === this.props.value,
      );
    }
    this.setState(
      {
        options: CategoryOptions,
        selected: selected,
      },
      () => {
        // Notify parent of default selection if not provided
        if (selected && this.props.onChange) {
          this.props.onChange(selected, this.props.did || 0);
        }
      },
    );
  }

  handleChange = (selectedOption) => {
    const id = this.props.did ? this.props.did : 0;
    let option = selectedOption;
    if (selectedOption == null) {
      option = { value: '', label: '' };
    }
    this.setState({ selected: selectedOption });
    this.props.onChange(option, id);
  };

  render() {
    const { options, selected } = this.state;
    return (
      <Select
        onChange={this.handleChange}
        isClearable={true}
        options={options}
        className="select-box-container vendor-selector-container"
        classNamePrefix="vendor-selector"
        name="vendor"
        placeholder="Select loan party"
        value={selected}
        isDisabled={this.props.disabled || false}
        menuPortalTarget={document.body}
      />
    );
  }
}

export { LoanPartyList };
